import React from "react"
import { price } from "../../dummydata"

const PriceCard = () => {
  return (
    <div className="pricing-grid">
      {price.map((val, index) => (
        <div 
          key={index} 
          className={`pricing-card ${val.popular ? 'popular' : ''}`}
          style={{ '--accent-color': val.color }}
        >
          {val.popular && (
            <div className="popular-badge">
              <span>Most Popular</span>
            </div>
          )}
          
          <div className="card-header">
            <h3 className="plan-name">{val.name}</h3>
            <p className="plan-description">{val.desc}</p>
          </div>
          
          <div className="card-pricing">
            <div className="price-container">
              <span className="currency">Rs.</span>
              <span className="price">{val.price}</span>
              <span className="period">{val.period}</span>
            </div>
          </div>
          
          <div className="card-features">
            <ul>
              {val.features.map((feature, featureIndex) => (
                <li key={featureIndex}>
                  <svg className="check-icon" viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
          
          <div className="card-action">
            <button className="enroll-btn">
              {val.popular ? 'Get Started Now' : 'Choose Plan'}
            </button>
          </div>
        </div>
      ))}
    </div>
  )
}

export default PriceCard
